<div [formGroup]="genderForm">
  <div class="input-form-box">
    <h1 class="label">{{ 'FORM.LABELS.GENDER' | translate }}*</h1>
    <div class="input-box">
      <input
        [ngStyle]="{'border': (submitted && genderControl?.hasError('required')) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
        readonly
        formControlName="gender"
        placeholder="{{ 'FORM.PLACEHOLDER.GENDER' | translate }}"
        (click)="openGenderModal(true)"
        [value]="getGenderDisplayValue()"
      />
      <div class="dropdown-arrow"></div>
    </div>
    <span
      *ngIf="submitted && genderControl?.hasError('required')"
      class="error-message"
    >
      {{ 'FORM.ERROR.REQUIRED' | translate }}
    </span>
    <span
      *ngIf="submitted && genderControl?.invalid && !genderControl?.hasError('required')"
      class="error-message"
    >
      {{ 'FORM.ERROR.INVALID' | translate }}
    </span>
  </div>

  <!-- Modal de sélection du genre -->
  <ion-modal
    [initialBreakpoint]="1"
    [breakpoints]="[0, 1]"
    (ionModalDidDismiss)="openGenderModal(false)"
    [isOpen]="genderModal"
  >
    <ng-template class="gender-modal-template">
      <div class="modal-wrapper">
        <div class="search-country-block">
          <div class="btn-return-b">
            <button
              class="return-btn"
              (click)="openGenderModal(false)"
            ></button>
            <h2>{{ 'FORM.LABELS.GENDER' | translate }}</h2>
          </div>
        </div>
        <div
          class="gender-option"
          *ngFor="let option of genderOptions"
          (click)="selectGender(option)"
          class="radio"
        >
          <input
            [id]="option.value"
            name="gender"
            [value]="option.value"
            type="radio"
            [checked]="genderControl?.value === option.value"
          />
          <label [for]="option.value" class="radio-label">
            <span>{{ option.label | translate }}</span>
          </label>
        </div>
      </div>
    </ng-template>
  </ion-modal>
</div>
